import { createApp } from 'vue';
import Mp3ToWavConverter from '@/Components/Mp3ToWavConverter.vue';
import '@styles/app.css';

createApp(Mp3ToWavConverter).mount('#mp3-to-wav-converter');
